export const authRouteName = {
  callback: "auth.callback",
};

export const authRoute = [
  {
    path: "/auth/callback",
    name: authRouteName.callback,
    component: () => import("../pages/AuthCallbackPage.vue"),
    meta: {
      requireAuth: false,
      layout: "plain",
    },
  },
];
